import { DefaultFocusStatusModel } from "../../../models/DefaultFocusStatusModel";
import { KeyboardNavigation } from "./KeyboardNavigation";

export class DefaultNavigation extends KeyboardNavigation {
    findNextFocusableElementWithinSameVariable(
        currentElement: DefaultFocusStatusModel,
        eventKey: string,
    ): DefaultFocusStatusModel | null {
        if (this.isHybridGrid && (eventKey === "ArrowLeft" || eventKey === "ArrowRight")) {
            return this.findNextFocusableElementWithinSameVariableCommonForHybridGrid(
                currentElement,
                eventKey,
            );
        }

        if (this.isHybridGrid && (eventKey === "ArrowDown" || eventKey === "ArrowUp")) {
            return this.findNextFocusableElementWithinSameVariableCommonForSwitchingRowsForHybridGrid(
                currentElement,
                eventKey,
            );
        }

        return null;
    }

    findNextFocusableElementWithinNextVariable(
        currentElement: DefaultFocusStatusModel,
    ): DefaultFocusStatusModel | null {
        if (this.isHybridGrid) {
            return this.findNextFocusableElementWithinNextVariableCommonForHybridGrid(
                currentElement,
            );
        }

        return this.findNextFocusableElementWithinNextVariableCommon(currentElement);
    }

    findLastFocusableElementWithinPreviousVariable(
        currentElement: DefaultFocusStatusModel,
    ): DefaultFocusStatusModel | null {
        const index = this.defaultFocusStatus.statuses.indexOf(currentElement);

        for (let i = index - 1; i >= 0; i--) {
            const elementFocusStatus = this.defaultFocusStatus.statuses[i];
            if (elementFocusStatus.variableId !== 0 &&
                elementFocusStatus.elementRef?.current &&
                elementFocusStatus.elementId !== currentElement.elementId) {
                return this.getFocusableElement(elementFocusStatus);
            }
        }
        return null;
    }
}
